export const isValidNumber = (value: any): boolean => {
  if (value === null) return false
  if (value === undefined) return false
  return typeof value === 'number'
}
